/* eslint-disable no-case-declarations */
import Checkbox from "common/components/Checkbox";
import Input from "common/components/Input/Input";
import React from "react";
import "./HeaderFilterCourses.scss";
import { HeaderFilterCoursesProps } from ".";

const HeaderFilterCoursesDesktop = ({
  title = "הגנה",
  onChangeText,
  value,
  onLastExercise,
  onChangeLevel,
  levels,
  dataLastExercise
}: HeaderFilterCoursesProps) => {
  return (
    <div className="header-filter-courses-desktop-wrapper">
      <div style={{ display: "flex" }}>
        <h3 className="heading">{title}</h3>
        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
          <Input
            placeholder="חיפוש"
            onChange={(val) => onChangeText && onChangeText(val.target.value)}
            value={value}
            showSearchIcon={true}
            showClearButton={!!value}
            onClear={() => onChangeText && onChangeText("")}
          />
        </div>
      </div>
      <div className="btn-check-main">
        <div className="action">
          {dataLastExercise && (
            <span
              className="last-exercise-btn"
              style={{ cursor: "pointer" }}
              onClick={onLastExercise}>
              תרגיל אחרון
            </span>
          )}
        </div>
        <ul className="RadioCheckButton-ul">
          <li className="RadioCheckButton-li">
            <Checkbox label="ראשוני" checked={levels?.ease} onClick={() => onChangeLevel("ease")} />
          </li>
          <li className="RadioCheckButton-li">
            <Checkbox
              label="בסיסי"
              checked={levels?.medium}
              onClick={() => onChangeLevel("medium")}
            />
          </li>
          <li className="RadioCheckButton-li">
            <Checkbox label="מתקדם" checked={levels?.hard} onClick={() => onChangeLevel("hard")} />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HeaderFilterCoursesDesktop;
